__turbopack_context__.v({
  "infoIcon": "verifyEmail-module-scss-module__L52qvq__infoIcon",
  "infoNotice": "verifyEmail-module-scss-module__L52qvq__infoNotice",
  "pageDesc": "verifyEmail-module-scss-module__L52qvq__pageDesc",
  "verifyEmailWrapper": "verifyEmail-module-scss-module__L52qvq__verifyEmailWrapper",
  "wrapper": "verifyEmail-module-scss-module__L52qvq__wrapper",
});
